/* @flow weak */
import {Record, fromJS, List} from 'immutable';

import * as creditActions from './actions';

const State = Record({
    page: 0,
    limit: 63,
    max: 0,
    habitues: List(),
    openHabituesPanel: false
});

const PAGE = 'page';
const MAX = 'max';
const HABITUES = 'habitues';
const OPEN_HABITUES_PANEL = 'openHabituesPanel';

const creditBillReducer = (state = new State(), action) => {

    switch (action.type) {
        case creditActions.FETCH_HABITUE_LIST_START: {
            return state.set(HABITUES, List());
        }
        case creditActions.FETCH_HABITUE_LIST_SUCCESS: {
            const {page, habitues, max} = action.payload.data;
            return state
                .set(PAGE, page)
                .set(HABITUES, fromJS(habitues))
                .set(MAX, max);
        }
        case creditActions.FETCH_HABITUE_LIST_ERROR: {
            return state.set(OPEN_HABITUES_PANEL, false);
        }
        case creditActions.OPEN_CREDIT_LIST_USERS: {
            const {open} = action.payload;
            return state
                .set(OPEN_HABITUES_PANEL, open);
        }
        case creditActions.CLEAN_HABITUE_LIST: {
            return state
                .set(PAGE, 0)
                .set(HABITUES, List())
                .set(MAX, 0);
        }
        case creditActions.DO_CREDIT_SUCCESS: {
            return state.set(OPEN_HABITUES_PANEL, false);
        }
    }

    return state;

};

export default creditBillReducer;



// WEBPACK FOOTER //
// ./src/common/creditBill/reducer.js